import * as React from "react";
import { GenericChartComponent } from "@react-financial-charts/core";
export class SVGComponent extends React.Component {
    render() {
        const { children } = this.props;
        return React.createElement(GenericChartComponent, { drawOn: [], svgDraw: children });
    }
}
//# sourceMappingURL=SVGComponent.js.map